<template>
  <div class="schedule-step">


    <!-- 赛程主体：横向分布（完全匹配图中布局） -->
    <div class="schedule-container">
      <div class="schedule-item" v-for="(step, index) in props.data.steps" :key="index">
        <!-- 阶段标识（图中圆形阶段号+文字） -->
        <div class="schedule-stage">
          <div class="stage-circle">{{ index + 1 }}</div>
          <div class="stage-text">{{ step.stage }}</div>
        </div>

        <!-- 赛程内容卡片（白底+浅边框，图中样式） -->
        <div class="schedule-card">
          <p class="card-desc">{{ step.desc }}</p>
        </div>

        <!-- 横向连接线（图中阶段间的粉色虚线） -->
        <div class="schedule-connector" v-if="index < props.data.steps.length - 1"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

// 保留原始props定义
const props = defineProps({
  data: { type: Object, required: true },
  theme: { type: Object, required: true }
});
</script>

<style scoped lang="scss">
// 核心变量（白底风格，匹配其他模块）
$primary: v-bind('props.theme.primaryColor'); // 主题粉（仅点缀）
$bg-white: #FFFFFF;                          // 统一白底
$text-dark: #333333;                         // 标题深色
$text-gray: #666666;                         // 内容灰色
$border-light: #F5F5F5;                      // 浅灰边框
$shadow: 0 4px 8px rgba(0, 0, 0, 0.02);      // 极弱阴影（图中风格）
$radius: 8px;                                // 圆润圆角

// 外层容器
.schedule-step {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

// 标题栏（和大赛简介模块风格统一）
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  padding-bottom: 16px;
  border-bottom: 1px solid $border-light;

  .section-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: $primary;
    color: $bg-white;
    font-size: 18px;
    font-weight: 600;
    margin-right: 12px;
  }

  .section-title {
    font-size: 24px;
    color: $text-dark;
    font-weight: 600;
    margin: 0;
  }

  .section-desc {
    font-size: 14px;
    color: $text-gray;
    margin: 0 0 0 16px;
    line-height: 1.5;
  }
}

// 赛程容器：横向分布，自适应屏幕
.schedule-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0; // 去掉默认间距，靠connector控制
  width: 100%;
}

// 单个赛程项：占比均等
.schedule-item {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 250px; // 小屏不挤压
  padding: 0 16px;
}

// 阶段标识（图中左侧圆形+文字）
.schedule-stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  flex-shrink: 0;

  .stage-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: $primary;
    color: $bg-white;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }

  .stage-text {
    font-size: 16px;
    color: $text-dark;
    font-weight: 600;
  }
}

// 赛程卡片（图中白底卡片样式）
.schedule-card {
  background: $bg-white;
  border: 1px solid $border-light;
  border-radius: $radius;
  padding: 20px;
  width: 100%;
  box-shadow: $shadow;

  .card-desc {
    font-size: 14px;
    color: $text-gray;
    line-height: 1.8;
    margin: 0;
  }
}

// 横向连接线（图中粉色虚线）
.schedule-connector {
  width: 40px;
  height: 2px;
  background-image: linear-gradient(to right, $primary 50%, transparent 50%);
  background-size: 8px 2px;
  background-repeat: repeat-x;
  flex-shrink: 0;
}

// 响应式适配（小屏纵向排列）
@media (max-width: 992px) {
  .schedule-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
  }

  .schedule-item {
    width: 100%;
    min-width: auto;
  }

  .schedule-connector {
    width: 2px;
    height: 40px;
    background-image: linear-gradient(to bottom, $primary 50%, transparent 50%);
    background-size: 2px 8px;
    margin-left: 17px; // 对齐圆形中心
  }
}

@media (max-width: 768px) {
  .section-header {
    margin-bottom: 32px;
  }

  .schedule-card {
    padding: 16px;
  }

  .card-desc {
    font-size: 13px;
  }
}
</style>